import React, { useState } from "react";
import { Drawer } from "@mui/material";
import InviteGroupMember from "./InviteGroupMember";
import InvitePopup from "../../../common/InvitePopup";
import useAppSelectors from "../../../customHooks/useAppSelectors";

const AddMemberGroupDrawer = ({
  isaddmemberOpen,
  handleCloseAddPeopleDrawer,
}) => {
  const { selectedGroup } = useAppSelectors();
  const [isInviteOpen, setInviteOpen] = useState(false);
  const handleOpenMenu = () => {
    setInviteOpen(true);
  };

  const handleCloseMenu = () => {
    setInviteOpen(false);
  };
  return (
    <React.Fragment>
      {isInviteOpen && (
        <InvitePopup
          closePopUp={handleCloseMenu}
          isGroupInvite={true}
          groupData={selectedGroup}
        />
      )}
      <Drawer sx={{ zIndex: 1202 }} open={isaddmemberOpen} anchor={"right"}>
        <InviteGroupMember
          handleCloseAddPeopleDrawer={handleCloseAddPeopleDrawer}
          handleOpenMenu={handleOpenMenu}
        />
      </Drawer>
    </React.Fragment>
  );
};

export default AddMemberGroupDrawer;
